import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxHmCarouselModule } from 'ngx-hm-carousel';
import { NoContentComponent } from '../no-content/no-content.component';
import { GtCompanyLogoComponent } from './components/gt-company-logo/gt-company-logo.component';
import { GtIconInputComponent } from './components/gt-icon-input/gt-icon-input.component';
import { GtLoadingComponent } from './components/gt-loading/gt-loading.component';
import { GtToastComponent } from './components/gt-toast/gt-toast.component';
import { GtUserGreetingComponent } from './components/user-greeting/gt-user-greeting.component';
import { GtAutofocusDirective } from './directives/gt-autofocus.directive';
import { GtCalendarTimePipe } from './pipes/gt-calendar-time.pipe';
import { APP_SERVICES } from './services/index';
import { UtilsService } from './services/utils';
import { GtAppLoaderComponent } from './components/gt-app-loader/gt-app-loader.component';

const NG_BOOTSTRAP_MODULES_FOR_ROOT = [
  NgbAlertModule,
  NgxHmCarouselModule,
];

const NG_BOOTSTRAP_MODULES = [
  NgbAlertModule,
  NgxHmCarouselModule,
];

@NgModule({
    imports: [
        ...NG_BOOTSTRAP_MODULES_FOR_ROOT,
        CommonModule,
        FormsModule,
        BrowserModule,
        GtAutofocusDirective,
        GtIconInputComponent,
        GtLoadingComponent,
        GtToastComponent,
        GtCompanyLogoComponent,
        NoContentComponent,
        GtUserGreetingComponent,
        GtCalendarTimePipe,
        GtAppLoaderComponent,
    ],
    exports: [
        ...NG_BOOTSTRAP_MODULES,
        GtAutofocusDirective,
        GtIconInputComponent,
        GtLoadingComponent,
        GtToastComponent,
        GtCompanyLogoComponent,
        NoContentComponent,
        GtUserGreetingComponent,
        GtCalendarTimePipe,
        GtAppLoaderComponent
    ],
    providers: [
        ...APP_SERVICES,
        UtilsService,
    ],
})
export class CoreModule {
}
